import { Link } from 'react-router-dom'
import './navigation.css'

/**
 * @param {{ label: string, to?: string }[]} items - Last item is current page (no link)
 */
export function Breadcrumbs({ items = [] }) {
  if (!items.length) return null

  return (
    <nav aria-label="Brødkrummer">
      <ol className="breadcrumbs">
        {items.map((item, i) => {
          const isLast = i === items.length - 1
          return (
            <li key={item.label + i}>
              {isLast || !item.to ? (
                <span aria-current={isLast ? 'page' : undefined}>{item.label}</span>
              ) : (
                <Link to={item.to}>{item.label}</Link>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
